module.exports = __webpack_public_path__ + "static/media/24.8b5bf415.jpg";